// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8aa33ea8","507":"04d35f26"}[chunkId] + ".chunk.js";
};